import { Outlet } from "react-router-dom";

const LotteryIndex = () => {
  return <Outlet />
}
export default LotteryIndex;
